/**
 
* Site URL Configuration
 
* All URLs are configurable via environment variables for different deployment environments.
 
*/
 
 
/** Laravel API backend base URL - used for all API calls (auth, jobs, users, etc.) */
 
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://employer-api-dev.drjobpro.net";
 
 
/** FastAPI AI service base URL - used for AI-powered features (resume parsing, job matching, etc.) */
 
export const AI_BASE_URL = process.env.REACT_APP_AI_BASE_URL || "https://employer-ai.drjobpro.net";
 
 
/** Current React application URL - used for generating internal links and redirects */
 
export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://employer.drjobpro.net";
 
 
/** WebSocket server URL - used for real-time features (notifications, chat, etc.) */
 
export const SOCKETURL = process.env.REACT_APP_SOCKET_URL || "";
 
 
/** External meeting platform URL - used for instant video call redirects (jobseeker login for meetings) */
 
export const MEET_EXTERNAL_URL = process.env.REACT_APP_MEET_EXTERNAL_URL || "https://www.drjobpro.com/";
 
 
/** Main DrJob public website URL - used for viewing public job listings and candidate profiles */
 
export const EXTERNAL_URL = process.env.REACT_APP_EXTERNAL_URL || "https://www.drjobpro.com/";
 
 
/** DrJob UAE website URL - used for UAE-specific job listings and profiles */
 
export const EXTERNAL_AE_URL = process.env.REACT_APP_EXTERNAL_AE_URL || "https://www.drjobs.ae/";
 